module.exports = __webpack_public_path__ + "img/carrousel-rad-digi-sala-5.ed96aff2.png";